import initialState from './initialState';
import { reducer as fetchOrdersReducer } from './fetchManageOutsOrders';
import { reducer as fetchAuditReducer } from './fetchAuditTrailLogs';
import { reducer as fetchStateCompareReducer } from './fetchManageOutsStateCompare';
import { reducer as exportHistorySearchReducer } from './exportHistorySearch';
import { reducer as exportHistoryTrackReducer } from './exportHistoryTrack';
import { MANAGE_OUTS_RESET_DATA } from './constants';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case MANAGE_OUTS_RESET_DATA:
      return { ...initialState };

    default:
      // delegate to sub-reducers to keep parity with existing patterns
      return exportHistoryTrackReducer(
        exportHistorySearchReducer(
          fetchAuditReducer(
            fetchStateCompareReducer(
              fetchOrdersReducer(state, action),
              action,
            ),
            action,
          ),
          action,
        ),
        action,
      );
  }
}

